import { ChangeDetectionStrategy, Component } from '@angular/core';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';
import { INoRowsOverlayParams } from 'ag-grid-community';
import { Icon } from '@y42/core/icon';

export interface DataNoRowOverlayParams {
  text: string;
  body: string;
  icon?: Icon;
}

type IDataNoRowOverlayParams = INoRowsOverlayParams & DataNoRowOverlayParams;

@Component({
  selector: 'y42-data-no-row-overlay',
  templateUrl: './data-no-row-overlay.component.html',
  styleUrls: ['./data-no-row-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataNoRowOverlayComponent implements INoRowsOverlayAngularComp {
  public params!: IDataNoRowOverlayParams;

  agInit(params: IDataNoRowOverlayParams): void {
    this.params = params;
  }
}
